import { InputType } from '@sofology/sofologycomponents';

import { ComponentTypeDescription } from 'models';

export const getInputTypeByComponentTypeDescription = (componentType: string): InputType => {
    switch (componentType) {
        case ComponentTypeDescription.Text:
        case ComponentTypeDescription.Number:
        case ComponentTypeDescription.Address:
        case ComponentTypeDescription.SortCode:
            return InputType.TextInput;
        case ComponentTypeDescription.RadioGroup:
            return InputType.Radio;
        case ComponentTypeDescription.Select:
            return InputType.Selector;
        case ComponentTypeDescription.Date:
            return InputType.DatePicker;
        case ComponentTypeDescription.CheckBox:
            return InputType.Checkbox;
        default:
            return InputType.TextInput;
    }
};